export type RuleGroupOp = 'and' | 'or';

export type RuleLeafBase = {
  id: string;
  kind: string;
};

export type RuleGroupNode<TLeaf extends RuleLeafBase> = {
  id: string;
  kind: 'group';
  op: RuleGroupOp;
  children: RuleNode<TLeaf>[];
  negated?: boolean;
};

export type RuleNode<TLeaf extends RuleLeafBase> = RuleGroupNode<TLeaf> | TLeaf;

export function isRuleGroupNode<TLeaf extends RuleLeafBase>(node: RuleNode<TLeaf>): node is RuleGroupNode<TLeaf> {
  return node.kind === 'group';
}

export type CreateGroupNodeFn<TLeaf extends RuleLeafBase> = (
  children?: RuleNode<TLeaf>[],
  op?: RuleGroupOp,
) => RuleGroupNode<TLeaf>;
